import './styles-roi-calculator.scss';

import { load } from './roi-calculator/roi-calculator-loader';

load();
